import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import statusReducer from "./statusReducer";
//import adverReducer from "./adverReducer";
import dealsReducer from "./dealsReducer";

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  statusMsg: statusReducer,
  // advertise: adverReducer,
  deals: dealsReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js